module.exports = __webpack_public_path__ + "img/cr.053b83b.svg";